import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import { ServicesList, ServiceDetail, BookingPage } from "@/pages/Services";
import { ShopList, ProductDetail, CartPage } from "@/pages/Shop";
import { CheckoutPage, CheckoutSuccess, CheckoutCancel } from "@/pages/Checkout";
import { Login, Register } from "@/pages/Auth";
import { MyOrders, OrderDetail } from "@/pages/Orders";
import Admin from "@/pages/Admin";

function CustomerLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function Shell() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/*" element={<Admin />} />
      </Routes>
    );
  }
  return (
    <CustomerLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servizi" element={<ServicesList />} />
        <Route path="/servizi/:slug" element={<ServiceDetail />} />
        <Route path="/prenota/:slug" element={<BookingPage />} />
        <Route path="/shop" element={<ShopList />} />
        <Route path="/shop/:slug" element={<ProductDetail />} />
        <Route path="/carrello" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/cancel" element={<CheckoutCancel />} />
        <Route path="/accedi" element={<Login />} />
        <Route path="/registrati" element={<Register />} />
        <Route path="/ordini" element={<MyOrders />} />
        <Route path="/ordini/:id" element={<OrderDetail />} />
        <Route path="*" element={<div className="max-w-3xl mx-auto px-6 py-20 text-center"><h1 className="font-serif text-5xl">404</h1><p className="mt-4 text-[#5C5A56]">Pagina non trovata.</p></div>} />
      </Routes>
    </CustomerLayout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Shell />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
